import { createAction } from 'redux-actions'

export const onSnapshotTaking = createAction('ON_SNAPSHOT_TAKING')
export const onSnapshotRequestReceived = createAction('ON_SNAPSHOT_REQUEST_RECEIVED')
export const onSnapshotCreated = createAction('ON_SNAPSHOT_CREATED')
export const onSnapshotProgressStateUpdate = createAction('ON_SNAPSHOT_PROGRESS_STATE_UPDATE')
